exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand-enter-active,\n.expand-leave-active {\n  -webkit-transition: height 600ms ease-in-out;\n  -moz-transition: height 600ms ease-in-out;\n  -ms-transition: height 600ms ease-in-out;\n  -o-transition: height 600ms ease-in-out;\n  transition: height 600ms ease-in-out;\n  overflow: hidden;\n}\n.expand-enter,\n.expand-leave-to {\n  height: 0;\n}\n", ""]);

// exports
